window.hasMap = $('#map').length > 0;

const properties = {
    "data": window.properties
};

function transformHtmlContent(property, element, isImg = false) {
    const image = 'img/logo.png';
    let replaces = {};

    replaces.id = '';
    if (property.id) {
        replaces.id = property.id
    }

    if (isImg) {
        replaces.image = 'src="';
    } else {
        replaces.image = "background-image : url(\'";
    }

    if (property.images.length > 0) {
        replaces.image += property.images[0].image
    } else {
        replaces.image += property.category.default_image;
    }

    if (isImg) {
        replaces.image += '"'
    } else {
        replaces.image += "');";
    }

    replaces.pickup = '';
    if (property.pickup && property.delivery) {
        replaces.pickup = "<i class='fa fa-truck'></i> " + property.pickup_city.cidade + " <i class='fa fa-arrow-right' style='margin-right: 4px;'></i> " + property.delivery_city.cidade;
    }

    replaces.label = 'N/A';
    if (property.label) {
        replaces.label = property.label
    }

    replaces.description = '';
    if (property.description) {
        replaces.description = property.description;
    }

    replaces.price_type = '';
    if (property.price_type === 0) {
        replaces.price_type = "Propostas";
    }
    if (property.price_type === 1) {
        replaces.price_type = "Preço Fixo";
    }
    if (property.price_type === 3) {
        replaces.price_type = "Mínimo Máximo";
    }

    replaces.address = '';
    if (property.zip) {
        replaces.address = property.zip
    }
    if (property.zip && property.city) {
        replaces.address = replaces.address + ' - ' + property.city
    }

    replaces.description = '';
    if (property.description) {
        replaces.description = property.description
    }

    replaces.price = 'Propostas';
    if (property.price_1) {
        if (property.price_type === 1) {
            replaces.price = property.price_1 + '€'
        }
        if (property.price_type === 2) {
            replaces.price = property.price_1 + '€ - ' + property.price_2 + '€'
        }
    }


    /*
    var is_featured = '';
    if (property.is_featured) {
        is_featured = '<div class="property-tag button alt featured">Featured</div> ';
    }
     */

    replaces.created_at = '';
    if (property.created_at) {
        replaces.created_at = property.created_at
    }

    replaces.user = '';
    if (property.user) {
        replaces.user = property.user.first_name + ' ' + property.user.last_name;
    }

    replaces.link = window['APP_URL'] + '/ad/' + property.uuid + '/view';

    $.each(replaces, function (index, value) {
        element = element.replaceAll('{' + index + '}', value);
    });

    return element;
}

function drawInfoWindow(property) {
    return transformHtmlContent(property, $('#map_list_result_window').html());
}

function insertPropertyToArray(property) {
    return transformHtmlContent(property, $('#map_list_result').html(), true);
}

function searchMarker(marker) {
    let filters = {};
    if (typeof marker === 'undefined') {
        return false;
    }
    $('#map-search-form').find('select, input').each(function () {
        filters[$(this).attr('name')] = $(this).val();
    });

    //* Text Search
    /*
    var markerTextSearch = (marker.label).toLowerCase() + ' ' + (marker.description).toLowerCase();
    if(filters.search && filters.search !== '' && markerTextSearch.indexOf((filters.search).toLowerCase()) < 0) {
        return false;
    }

    //* Price Type
    if(filters.price_type !== '' && filters.price_type !== null) {
        filters.price_type = parseInt(filters.price_type);
    }
    if(filters.price_type !== '' && filters.price_type !== parseInt(marker.price_type)) {
        return false;
    }

    //* Prices
    if(filters.price_type !== '' && filters.price_type !== null) {
        if (filters.price_type === 1) {
            if (parseFloat(marker.price_1) < parseFloat(filters.min_price) || parseFloat(marker.price_1) > parseFloat(filters.max_price)) {
                return false;
            }
        }
        if (filters.price_type === 2) {
            if (parseFloat(marker.price_1) < parseFloat(filters.min_price) || parseFloat(marker.price_2) > parseFloat(filters.max_price)) {
                return false;
            }
        }
    }
    */
    //* Categories
    if (filters.category_id !== '' && filters.category_id !== null) {
        if (parseInt(filters.category_id) !== parseInt(marker.category_id)) {
            return false;
        }
    }

    /*
    //* Subcategories
    if(filters.subcategory_id !== '' && filters.subcategory_id !== null) {
        if(parseInt(filters.subcategory_id) !== parseInt(marker.subcategory_id)) {
            return false;
        }
    }
     */
    return true;
}

function animatedMarkers(map, propertiesMarkers, properties, layout, ignoreSearch = false) {
    const bounds = map.getBounds();
    const propertiesArray = [];
    $.each(propertiesMarkers, function (key, value) {
        if (bounds.contains(propertiesMarkers[key].getLatLng())) {
            if (ignoreSearch === false && searchMarker(properties.data[key])) {
                propertiesArray.push(insertPropertyToArray(properties.data[key]));
            }
            setTimeout(function () {
                if (propertiesMarkers[key]._icon != null) {
                    propertiesMarkers[key]._icon.className = 'leaflet-marker-icon leaflet-zoom-animated leaflet-clickable bounce-animation marker-loaded';
                }
            }, key * 50);
        } else {
            if (propertiesMarkers[key]._icon != null) {
                propertiesMarkers[key]._icon.className = 'leaflet-marker-icon leaflet-zoom-animated leaflet-clickable';
            }
        }
    });
    //$('.fetching-properties').html(propertiesArray);
}

window.generateMap = function generateMap(latitude, longitude, mapProvider, layout, geolocationPermission) {
    if ($('#map').length > 0) {
        const map = L.map('map', {
            center: [latitude, longitude],
            zoom: 14,
            scrollWheelZoom: false
        });

        const providers = {
            "Google-Map": L.tileLayer(
                "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}",
                {
                    minZoom: 2,
                    maxZoom: 19,
                    id: "google.street"
                }
            ),
        };


        L.tileLayer.provider(mapProvider).addTo(map);

        L.tileLayer('https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        const markers = L.markerClusterGroup({
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true
        });
        const propertiesMarkers = [];

        $.each(properties.data, function (index, property) {
            if (searchMarker(properties.data[index])) {
                let icon = '<img src="images/logos/logo.png">';
                if (property.images[0] && property.images[0].image) {
                    icon = '<img src="' + property.images[0].image + '">';
                } else {
                    icon = '<img src="' + property.category.default_image + '">';
                }
                const color = '';
                const markerContent =
                    '<div class="map-marker map-marker-category-' + property.category.id + '">' +
                    '<div class="icon" style="border-color: ' + property.category.color + '">' +
                    icon +
                    '</div>' +
                    '</div>';

                const _icon = L.divIcon({
                    html: markerContent,
                    iconSize: [36, 46],
                    iconAnchor: [18, 32],
                    popupAnchor: [130, -28],
                    className: ''
                });

                const marker = L.marker(new L.LatLng(property.latitude, property.longitude), {
                    title: property.title,
                    icon: _icon
                });

                propertiesMarkers.push(marker);
                marker.bindPopup(drawInfoWindow(property));
                markers.addLayer(marker);
                marker.on('popupopen', function () {
                    this._icon.className += ' marker-active';
                });
                marker.on('popupclose', function () {
                    this._icon.className = 'leaflet-marker-icon leaflet-zoom-animated leaflet-clickable marker-loaded';
                });
            }
        });

        map.addLayer(markers);
        animatedMarkers(map, propertiesMarkers, properties, layout);
        map.on('moveend', function () {
            animatedMarkers(map, propertiesMarkers, properties, layout);
        });
        markers.on('clusterclick', function () {
            animatedMarkers(map, propertiesMarkers, properties, layout);
        });

        let radiusLayer = L.layerGroup();
        $('body').on('click', '#map-search-form button#search-btn', function () {
            window.infiniteScrollEnd = false;
            if (map.hasLayer(radiusLayer)) {
                map.removeLayer(radiusLayer);
                radiusLayer = L.layerGroup();
            }

            let createMapRadius = false;
            let radius = $('#map-search-form input[id="search_radius"]').val();
            if (radius !== '' && radius != 0) {
                radius = parseInt(radius);
                createMapRadius = true;
            }

            let changeCity = false;
            if ($('#map-search-form input[name="city"]').val() !== '') {
                changeCity = true;
                $.ajax({
                    url: $('#map').attr('data-coordinates-url'),
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        city: $('#map-search-form input[name="city"]').val()
                    },
                    success: function (data) {
                        if (data.status === true) {
                            map.setView(new L.LatLng(data.data.latitude, data.data.longitude), 14);
                        }
                        const circle = L.circle([data.data.latitude, data.data.longitude], radius * 1000).addTo(radiusLayer);
                        map.addLayer(radiusLayer);
                    }
                })
            }

            if (createMapRadius === true && changeCity === false) {
                const circle = L.circle([window.geolocation.latitude, window.geolocation.longitude], radius * 1000).addTo(radiusLayer);
                map.addLayer(radiusLayer);
            }


            if (typeof mCustomScrollbarResultsSidebar !== 'undefined') {
                loadMoreItems(mCustomScrollbarResultsSidebar, true, true);
            } else {
                loadMoreItems($('#map-content-sidebar'), true, true);
            }

            markers.clearLayers();
            $.each(properties.data, function (index, property) {
                if (searchMarker(properties.data[index])) {
                    let icon = '<img src="images/logos/logo.png">';
                    if (property.images[0] && property.images[0].image) {
                        icon = '<img src="' + property.images[0].image + '">';
                    } else {
                        icon = '<img src="' + property.category.default_image + '">';
                    }
                    const color = '';
                    const markerContent =
                        '<div class="map-marker map-marker-category-' + property.category.id + '">' +
                        '<div class="icon" style="border-color: ' + property.category.color + '">' +
                        icon +
                        '</div>' +
                        '</div>';

                    const _icon = L.divIcon({
                        html: markerContent,
                        iconSize: [36, 46],
                        iconAnchor: [18, 32],
                        popupAnchor: [130, -28],
                        className: ''
                    });

                    const marker = L.marker(new L.LatLng(property.latitude, property.longitude), {
                        title: property.title,
                        icon: _icon
                    });

                    propertiesMarkers.push(marker);
                    marker.bindPopup(drawInfoWindow(property));
                    markers.addLayer(marker);
                    marker.on('popupopen', function () {
                        this._icon.className += ' marker-active';
                    });
                    marker.on('popupclose', function () {
                        this._icon.className = 'leaflet-marker-icon leaflet-zoom-animated leaflet-clickable marker-loaded';
                    });
                }
            });
            animatedMarkers(map, propertiesMarkers, properties, layout);
        });

        $('body').on('change', '.map-search-form-with-map select#search_category_id', function () {
            console.log($(this).val());
            $('#search_subcategory_id').html('');
            highlightHomepageCategories($(this).val());
            if ($('#map-search-form input[name="city"]').val() !== '') {
                $.ajax({
                    url: $('#map').attr('data-coordinates-url'),
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        city: $('#map-search-form input[name="city"]').val()
                    },
                    success: function (data) {
                        if (data.status === true) {
                            map.setView(new L.LatLng(data.data.latitude, data.data.longitude), 14);
                        }
                    }
                })
            }
            markers.clearLayers();
            $.each(properties.data, function (index, property) {
                if (searchMarker(properties.data[index])) {
                    let icon = '<img src="images/logos/logo.png">';
                    if (property.images[0] && property.images[0].image) {
                        icon = '<img src="' + property.images[0].image + '">';
                    } else {
                        icon = '<img src="' + property.category.default_image + '">';
                    }
                    const color = '';
                    const markerContent =
                        '<div class="map-marker map-marker-category-' + property.category.id + '">' +
                        '<div class="icon" style="border-color: ' + property.category.color + '">' +
                        icon +
                        '</div>' +
                        '</div>';

                    const _icon = L.divIcon({
                        html: markerContent,
                        iconSize: [36, 46],
                        iconAnchor: [18, 32],
                        popupAnchor: [130, -28],
                        className: ''
                    });

                    const marker = L.marker(new L.LatLng(property.latitude, property.longitude), {
                        title: property.title,
                        icon: _icon
                    });

                    propertiesMarkers.push(marker);
                    marker.bindPopup(drawInfoWindow(property));
                    markers.addLayer(marker);
                    marker.on('popupopen', function () {
                        this._icon.className += ' marker-active';
                    });
                    marker.on('popupclose', function () {
                        this._icon.className = 'leaflet-marker-icon leaflet-zoom-animated leaflet-clickable marker-loaded';
                    });
                }
            });
            animatedMarkers(map, propertiesMarkers, properties, layout);
        })


        $('.geolocation').on("click", function () {
            map.locate({setView: true, zoom: 14})
        });

        $('#map').removeClass('fade-map');

        if (geolocationPermission) {
            let locateController = L.control.locate({
                keepCurrentZoomLevel: true,
                locateOptions: {enableHighAccuracy: true}
            }).addTo(map);
            locateController.start();
        }
        
        return map;
    }
}

window.generateDetailMap = function generateDetailMap(latitude, longitude, mapProvider, layout, title, markerImage, markerColor, categoryID) {
    let detailMap = $('#map_details');
    if (detailMap.length > 0) {
        const map = L.map('map_details', {
            center: [latitude, longitude],
            zoom: 14,
            scrollWheelZoom: false
        });

        const providers = {
            "Google-Map": L.tileLayer(
                "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}&hl=pt-PT",
                {
                    minZoom: 2,
                    maxZoom: 19,
                    id: "google.street"
                }
            ),
        };


        L.tileLayer.provider(mapProvider).addTo(map);

        L.tileLayer('https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}&hl=pt-PT', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        const markers = L.markerClusterGroup({
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true
        });
        const propertiesMarkers = [];

        const markerContent =
            '<div class="map-marker map-marker-category-' + categoryID + '">' +
            '<div class="icon" style="border-color: ' + markerColor + '">' +
            '<img src="' + markerImage + '">' +
            '</div>' +
            '</div>';

        const _icon = L.divIcon({
            html: markerContent,
            iconSize: [36, 46],
            iconAnchor: [18, 32],
            popupAnchor: [130, -28],
            className: ''
        });

        const marker = L.marker(new L.LatLng(latitude, longitude), {
            title: title,
            icon: _icon
        });

        propertiesMarkers.push(marker);
        markers.addLayer(marker);

        map.addLayer(markers);

        animatedMarkers(map, propertiesMarkers, properties, layout, true);
        map.on('moveend', function () {
            animatedMarkers(map, propertiesMarkers, properties, layout, true);
        });

        detailMap.removeClass('fade-map');

        return map;
    }

}

